/* eslint eqeqeq: 0 */
import { combineReducers } from "redux";
import { List } from "immutable";
import dateRange from "./dateRange";
import WalletJournal from "../records/WalletJournal";

import { CLOSE_POPUP } from "../constants";

import * as constants from "../constants/payments";

function paymentList(state = new List(), action) {
  if (action.type == constants.ON_LOAD_PAYMENTS_SUCCESS) {
    return new List(action.payments).map(payment => new WalletJournal(payment));
  }

  return state;
}

function paymentsSort(state = { key: "time", order: "desc" }, action) {
  if (action.type == constants.SET_PAYMENTS_SORT) {
    return {
      key: action.key,
      order: action.order
    };
  }
  return state;
}

function paymentForm(state = { isOpen: false }, action) {
  if (action.type == constants.OPEN_PAYMENT_FORM) {
    return { isOpen: true };
  }
  if (action.type == CLOSE_POPUP) {
    return { isOpen: false };
  }

  return state;
}

export default combineReducers({
  dateRange: dateRange(constants.SET_PAYMENTS_LIST_DATE_RANGE),
  paymentList,
  paymentsSort,
  paymentForm
});
